import { Todo } from "@models/todo.model";

interface TodoRowProps {
  todo: Todo;
}

export default function TodoRow({ todo }: TodoRowProps) {
  return (
    <div className="mt-todo-row">
      <input type="checkbox" disabled aria-label="Todo not actionable yet" />
      <span className="mt-todo-row__name">{todo.name}</span>
    </div>
  );
}
